import { Component, Input } from '@angular/core';
import './imagesRowExploreWidgetNg2.html';

@Component({
    selector: 'images-row-explore-widget-ng2',
    template: require('./imagesRowExploreWidgetNg2.html')
})

export class ImagesRowExploreWidgetComponentNg2 {
    @Input() text1: string;
    @Input() value: number;
    @Input() images;

    constructor() {}
}


/** WEBPACK FOOTER **
 ** ./src/components/explore/widgets/imagesRowExploreWidgetNg2.ts
 **/